















import { Loading } from 'streamlabs-beaker';
import Component from 'vue-class-component';
import Base from './components/Base';
import CheckoutModalMini from './components/checkout/CheckoutModalMini.vue';
import { getModule } from 'vuex-module-decorators';
import AppModule from './store/modules/app';
import store from './store';
import StreamTipsModal from './components/editor/modals/StreamTipsModal.vue';
import FeedbackModal from './components/editor/modals/FeedbackModal.vue';
import { Watch } from 'vue-property-decorator';
import { EModalName } from './helpers/modal';
// import TermsModal from '@/components/modals/TermsModal.vue';
import ChangeOfTermsModal from '@/components/modals/ChangeOfTermsModal.vue';

@Component({
  components: {
    SLoading: Loading,
    CheckoutModalMini,
    FeedbackModal,
    StreamTipsModal,
    // TermsModal,
    ChangeOfTermsModal,
  },
})
export default class App extends Base {
  appModule = getModule(AppModule, store);

  get appIsLoading(): boolean {
    return this.appModule.appIsLoading;
  }

  @Watch('isLive')
  handler() {
    if (this.currentUser && !this.isLive && !this.userFlags.do_not_show_feedback_modal)
      this.$modal.show(EModalName.feedback);

    if (this.currentUser && this.isLive) {
      this.userModule.setYoutubeLiveVideoId(null);
      this.loadLastStreamSessionPlatforms();
    }

    if (!this.isLive) {
      this.userModule.setYoutubeLiveVideoId(null);
      this.userModule.setLivePlatforms([]);
    }
  }
}
